import React, { Dispatch, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import styles from "./left-column-header.module.scss";
import DropDownComponent from "./dropdown-menu/dropdown-menu.component";

import { ApplicationStore } from "~/app/application.store";
import { swapViewAction } from "~/app/views/views.actions";
import { ViewsApp } from "~/app/views/views.store";

const LeftColumnHeader: React.FC = () => {
  const dispatch: Dispatch<any> = useDispatch();

  const viewChatsOrCalls: ViewsApp = useSelector((state: ApplicationStore) => state.views.viewIsOpen);

  const swapViewChatsCalls: (isViewCalls: ViewsApp) => void = useCallback(
    (isViewCalls: ViewsApp) => {
      dispatch(swapViewAction(isViewCalls));
    },
    [dispatch]
  );

  return (
    <div className={styles.leftColumnHeader}>
      <DropDownComponent />
      <div
        className={styles.nameView}
        onClick={(): void => swapViewChatsCalls(viewChatsOrCalls == "Calls" ? "Chats" : "Calls")}
      >
        {viewChatsOrCalls}
      </div>
      <div>Add</div>
    </div>
  );
};

export default LeftColumnHeader;
